import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentFrom from "../../components/contentfrom";

function Gettouch({ color }) {
  let className = "gettouch p-100";
  if (color === "orange") {
    className = "gettouch p-100 bg_orange";
  }
  return (
    <div className={className}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="Conect">
              <h4>Got an Idea?</h4>
              <h2>Let's Shape Your Project Together!</h2>
            </div>
            <p>
              Ready to bring your app ideas to life? Share your vision, and
              let's kickstart your project journey.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <ContentFrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Gettouch;
